import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia, Typography } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import { fetchFarmerBillDetail, fetchLoadUnload } from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
  validatedate_min_max,
  isNumeric,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import { apiFarmerURL } from "./API";
import CtART from "./CustomTool/ResponsiveTable";

class FarmerBillEntryList extends Component {
  state = {
    formData: {
      dtpFromDate: get_30DaysBack_FromCurrentDate(),
      dtpToDate: get_YMD_from_SYS(new Date()),
      cmbDRP: "All",
    },

    columnsdata: [
      {
        accessorKey: "bint_inwardno",
        header: " ઈનવર્ડ નં.",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dat_inworddateDMY",
        header: "ઈનવર્ડ તારીખ",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_farmername",
        header: " ખેડૂતનું નામ",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_fathername",
        header: "પિતાનું નામ ",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_village",
        header: "ગામ",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_itemtotal",
        header: " આઇટમ ટોટલ",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        isNumeric: true,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        accessorKey: "dec_truckrate",
        header: "ટ્રક રેન્ટ",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_minusloading",
        header: " બારદાન ",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_sutli",
        header: "સુતળી",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_upad",
        header: "ઉપાડ",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "dec_totalamount",
        header: "ટોટલ રકમ",
        size: 30,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        isNumeric: true,
        muiTableBodyCellProps: { align: "right" },
      },
      {
        accessorKey: "vac_transactiontype",
        header: "વાવહારનો પ્રકાર",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_paymenttype",
        header: "ચુકવણીનો પ્રકાર",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_remark",
        header: "રીમાર્ક",
        size: 50,
        enableColumnActions: false,
        enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      // {
      //   accessorKey: "vac_gender",
      //   header: "ખેડૂત બિલ આઇટમ લીસ્ટ",
      //   size: 60,
      // },
    ],
    rows: [{ bint_srno: 1 }],

    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,

    dataLoadStatus: true,
    ARD: null,
    removeKeyboardShortCuts: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account :ખેડૂત બિલ યાદી";
    this.props.setActiveMenu("FarmerbillList");
    this.ShortCut();
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }
  componentWillUnmount() {
    this.removeKeyboardShortCuts();
  }
  removeKeyboardShortCuts = () => {
    if (this.state.removeKeyboardShortCuts) {
      this.state.removeKeyboardShortCuts();
      this.setState({ removeKeyboardShortCuts: null });
    }
  };
  ShortCut = () => {
    this.setState({
      removeKeyboardShortCuts: setKeyboardShortcuts({
        handleOnclickAdd: this.handleOnNewEntryClick,
      }),
    });
  };
  //#endregion Component

  //#region Handle

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (row) => {
    let bint_acid = localStorage.getItem("acid"),
      bint_inwardno = row.getValue("bint_inwardno"),
      bint_acyear = localStorage.getItem("ACY");
    this.props.navigateTo("FarmerBillEntry", {
      bint_acid: bint_acid,
      bint_inwardno: bint_inwardno,
      bint_acyear: bint_acyear,
    });
  };

  reqDataForReport = (bolChkDataExist, row) => {
    let inwardNo = Number(row.getValue("bint_inwardno"));

    if (!inwardNo || inwardNo === 0) {
      this.props.updateProcessing("error", "Inward No is missing.");
      return;
    }

    let bint_inwardnofrom = inwardNo;
    let bint_inwardnoto = inwardNo;
    let dat_datefrom = "";
    let dat_dateto = "";
    let GenerateBillType = "InwardNo";

    return {
      Op: "KhedutMultipleBillPrint",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      bint_inwardnofrom: bint_inwardnofrom,
      bint_inwardnoto: bint_inwardnoto,
      dat_datefrom: dat_datefrom,
      dat_dateto: dat_dateto,
      GenerateBillType: GenerateBillType,
      bolChkDataExist: bolChkDataExist,
    };
  };

  openInvoiceKhedut = (row) => {
    this.props.notifyProcessing();
    let reqData = this.reqDataForReport(true, row);
    fetchFarmerBillDetail(reqData)
      .then((res) => {
        console.log("res", res);

        if (res.data.msgType === "info") {
          let reqData = this.reqDataForReport(false, row);

          console.log("open");

          // Use URLSearchParams to convert the request data object into a query string
          let params = new URLSearchParams(reqData);

          let popupURL =
            apiFarmerURL + "farmerbilldetail.php?" + params.toString();
          let popupWindow = window.open(
            popupURL,
            "SalesList",
            "width=" +
              window.screen.availWidth +
              ",height=" +
              window.screen.availHeight
          );
          this.props.updateProcessing("success", "PDF Open in popup.");
        } else {
          console.log("not open");

          this.props.updateProcessing(res.data.msgType, res.data.message);
        }
      })
      .catch((error) => {
        console.log("Unknown error occurred in openSalesReport.", error);
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in loading . " + error
        );
      });
    // Create a query string from the request data
  };

  openInvoiceKhedutOld = (row) => {
    let bint_acid = localStorage.getItem("acid"),
      bint_acyear = localStorage.getItem("ACY"),
      inwardNo = Number(row.getValue("bint_inwardno"));

    // let inwardNo = Number(row.getValue("bint_inwardno"));

    if (!inwardNo || inwardNo === 0) {
      this.props.updateProcessing("error", "Inward No is missing.");
      return;
    }

    let bint_inwardnofrom = inwardNo;
    let bint_inwardnoto = inwardNo;
    let dat_datefrom = "";
    let dat_dateto = "";
    let GenerateBillType = "InwardNo";

    this.props.notifyProcessing();

    let reqData = [
      { name: "Op", value: "KhedutMultipleBillPrint" },
      { name: "bint_acid", value: bint_acid },
      { name: "bint_acyear", value: bint_acyear },
      { name: "bint_inwardnofrom", value: bint_inwardnofrom },
      { name: "bint_inwardnoto", value: bint_inwardnoto },
      { name: "dat_datefrom", value: dat_datefrom },
      { name: "dat_dateto", value: dat_dateto },
      { name: "GenerateBillType", value: GenerateBillType },
    ];

    let queryString = reqData
      .map(
        (data) =>
          encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
      )
      .join("&");

    let popupURL = apiFarmerURL + "farmerbilldetail.php?" + queryString;

    let popupWindow = window.open(
      popupURL,
      "SalesList",
      "width=" +
        window.screen.availWidth +
        ",height=" +
        window.screen.availHeight
    );

    if (popupWindow) {
      popupWindow.focus();
    }

    this.props.updateProcessing("success", "PDF Open in popup.");
  };

  // handleARDonActionClick_Print = (row) => {
  //   const bint_inwardno = row.getValue("bint_inwardno");

  //   // console.log(bint_inwardno);

  //   this.openInvoiceKhedut(bint_inwardno);
  // };

  // openInvoiceKhedut1 = (bint_acid, bint_acyear, bint_inwardno) => {
  //   this.props.notifyProcessing();
  //   let reqData = [
  //     { name: "Op", value: "KhedutMultipleBillPrint" },
  //     { name: "bint_acid", value: bint_acid },
  //     { name: "bint_acyear", value: bint_acyear },
  //     { name: "bint_inwardnofrom", value: bint_inwardno },
  //     { name: "bint_inwardnoto", value: bint_inwardno },
  //     { name: "dat_datefrom", value: "" },
  //     { name: "dat_dateto", value: "" },
  //     { name: "GenerateBillType", value: "" },
  //     //   name: "SalesInvoiceSelection",
  //     //   value: JSON.stringify(CheckedInvoiceList),
  //     // },
  //     // { name: "PaperType", value: this.state.formData.cmbPaper },
  //   ];
  //   // Create a query string from the request data
  //   let queryString = reqData
  //     .map(
  //       (data) =>
  //         encodeURIComponent(data.name) + "=" + encodeURIComponent(data.value)
  //     )
  //     .join("&");

  //   // Set the URL of the popup window
  //   let popupURL = apiFarmerURL + "farmerbilldetail.php?" + queryString;

  //   // Open the popup window
  //   window.open(
  //     popupURL,
  //     "SalesList",
  //     "width=" +
  //       window.screen.availWidth +
  //       ",height=" +
  //       window.screen.availHeight
  //   );
  //                   this.props.updateProcessing("success", "PDF Open in popup.");
  // };

  onKhedutReportClick = () => {
    if (
      this.props.userPrivilege.Khedut != "" &&
      this.props.userPrivilege.Khedut != undefined &&
      this.props.userPrivilege.Khedut != "R"
    ) {
      this.navigateTo("KhedutBillPrint");
    }
  };

  handleARDonActionClick_Delete = (row) => {
    const bint_inwardno = row.getValue("bint_inwardno");

    // console.log(bint_inwardno);

    this.DeleteData(bint_inwardno);
  };

  DeleteData = (bint_inwardno) => {
    if (bint_inwardno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            // alertTitle={
            //   "Do you want Delete to Farmer Bill :" + bint_inwardno + " ?"
            // }
            alertTitle={
              " શું તમે ખેડૂત બિલ નં " +
              bint_inwardno +
              " ખેડૂત બિલ લીસ્ટ માં ડિલીટ કરવા માંગો છો ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteFarmerBill(bint_inwardno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  validate = () => {
    let result = false;
    if (this.state.formData.dtpFromDate.length <= 0) {
      this.props.toastErrorMsg("તારીખ ઉમેરો", "dtpFromDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpFromDate,
        "dtpFromDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else if (this.state.formData.dtpToDate.length <= 0) {
      this.props.toastErrorMsg("થી તારીખ ઉમેરો", "dtpToDate");
    } else if (
      validatedate_min_max(
        this.state.formData.dtpToDate,
        "dtpToDate",
        this.props.toastErrorMsg
      ) == false
    ) {
      return result;
    } else {
      result = true;
    }
    return result;
  };

  // setfrom_todate = (reset = false) => {
  //   setlocalstoragedate(
  //     "Loading",
  //     this.state.formData.dtpFromDate,
  //     this.state.formData.dtpToDate,
  //     reset
  //   );
  //   if (reset) {
  //     // window.location.reload();
  //     this.onFormLoad(reset);
  //     document.getElementById("dtpFromDate").focus();
  //   }
  // };

  DeleteFarmerBill = (bint_inwardno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteFarmerBill",
      bint_acid: localStorage.getItem("acid"),
      bint_acyear: localStorage.getItem("ACY"),
      bint_inwardno: bint_inwardno,
      // bol_list: true,
    };
    fetchFarmerBillDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.FarmerBillList && res.data.FarmerBillList.length > 0) {
            rows = res.data.FarmerBillList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.onFormLoad();
              // this.clearInfo();
            }
          );
          document.getElementById("dtpFromDate").focus();
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };
  handleOnNewEntryClick = () => {
    this.removeKeyboardShortCuts();
    this.props.navigateTo("FarmerBillEntry");
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  //#endregion handle

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      excludeKeysArray: ["chkReceiptGenerated"],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  getInfo = () => {};

  onFormLoad = () => {
    if (this.validate()) {
      let dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        let reqData = {
          Op: "LoadFarmerBill",
          bint_acid: localStorage.getItem("acid"),
          bint_acyear: localStorage.getItem("ACY"),
          dat_fromdate: this.state.formData.dtpFromDate,
          dat_todate: this.state.formData.dtpToDate,
          bint_inwardno: 0,
        };

        fetchFarmerBillDetail(reqData)
          .then((res) => {
            dataLoadStatus = true;
            let rows = [];
            if (res.data.FarmerBillList && res.data.FarmerBillList.length > 0) {
              rows = res.data.FarmerBillList;
              this.props.closeUpdateProcessing();
            } else {
              this.props.updateProcessing("error", "Data is Not Present");
            }
            this.setState(
              {
                dataLoadStatus,
                rows,
              },
              () => {
                document.getElementById("dtpFromDate").focus();
              }
            );
          })
          .catch((error) => {
            console.log("Unknown error occurred in onFormLoad.", error);
          });
      });
    }
  };

  handleOnList = () => {
    this.props.navigateTo("FarmerBillList");
  };

  render() {
    return (
      <from>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>ખેડૂત બિલ યાદી</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item style={{ display: "inline-flex" }}>
            <CardContent style={{ paddingBottom: "0px" }}>
              <CardMedia
                component="img"
                alt="Reset Date to Default"
                sx={{ width: 35 }}
                image={ResetDate}
                // onClick={() => {
                //   this.setfrom_todate(true);
                // }}
              />
            </CardContent>
            <CtDtp
              id="dtpFromDate"
              label="તારીખ*"
              width="170"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpFromDate}
              accountYear={localStorage.getItem("ACY")}
              value={this.state.formData.dtpFromDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="dtpToDate"
            />
          </Grid>

          <Grid item>
            <CtDtp
              id="dtpToDate"
              label="થી તારીખ*"
              width="170"
              handleOnChange={this.handleOnChange}
              defaultValue={this.state.formData.dtpToDate}
              accountYear={localStorage.getItem("ACY")}
              value={this.state.formData.dtpToDate}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.onFormLoad}
            />
          </Grid>

          {/* <Grid item>
            <CtBtn label="List" onClick={this.onFormload} />
          </Grid> */}

          <Grid item>
            <CtBtn
              variant={"outlined"}
              iconName={"load"}
              label="લીસ્ટ"
              onClick={() => {
                this.onFormLoad();
              }}
            />
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          {/* <MaterialTable
            rowsdata={this.state.rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("બિલ લીસ્ટ")}
            newBtnName={"નવી ખેડૂત બિલ એન્ટ્રી"}
            newBtnClick={this.handleOnNewEntryClick}
            onEditAction={this.handleARDonActionClick_Edit}
            onDeleteAction={this.handleARDonActionClick_Delete}
            onPrintAction={this.openInvoiceKhedut}
            showColumnFilters={false}
            actionColSize={60}
            density={"compact"}
            // toolTipNewEntry="Sales Entry"
          /> */}

          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columnsdata}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("LeaderGroup")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            tableButtonAction={[
              {
                label: "નવી ખેડૂત બિલ એન્ટ્રી",
                onClick: this.handleOnNewEntryClick,
                addPluseIcon: true,
              },
            ]}
            showColumnFilters={false}
            actionColSize={60}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </from>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(FarmerBillEntryList))));
